<template>
    <div class="video-nav">

        <!-- VIDEO NAVIGATION-->
        <div class="video-list" :class="{ 'is-active': isActive }">
            <div class="container">
                <ul>
                    <li v-for="video in VideoData.questions">
                        <button @click="playVideo(video.id)" class="video-thumb-wrap">
                            <video-thumbnail :video="video"> </video-thumbnail>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        <!-- END VIDEO NAVIGATION-->

        <div class="container">
            <div v-if="this.$route.name != 'Video'">
                <button @click="toggleVideoNav" class="btn btn-icon">{{ toggleLabel }}</button>
            </div>
        </div>
    </div>

</template>

<script>
    const TOGGLE_LABEL_DEFAULT = "Browse all videos";
    import VideoThumbnail from '../global/VideoThumbnail'
    export default {
        name: 'VideoNavigation',
        data: function () {
            return {
                isActive: false,
                toggleLabel: TOGGLE_LABEL_DEFAULT,
            }
        },
        components :{
            VideoThumbnail
        },
        props: ['VideoData'],
        methods: {
            toggleVideoNav: function(){
                this.isActive = !this.isActive;
                this.toggleLabel = this.isActive ? "Close all videos" : TOGGLE_LABEL_DEFAULT
            },
            playVideo: function(videoId){
                // Video has been selected, hide menu
                this.isActive = false;
                this.toggleLabel = TOGGLE_LABEL_DEFAULT;
                this.$router.push({
                    name: 'Video',
                    params: {
                        videoId: videoId
                    }
                });
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-list li,
.video-list li > div{
    display:inline;
}
.active{
    display:block;
}
</style>



// WEBPACK FOOTER //
// src/components/global/VideoNavigation.vue